<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="UploadInvoiceLines"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpAlert
      variant="info"
      show
    >
      <p>
        <ItpIcon
          fa="info-circle"
        >
        </ItpIcon>
        <ItpText
          wrap
        >
          Számlasorok a következő sablon kitöltésével tölthetők fel:

        </ItpText>
        <ItpLink
          :text="'Download template'|pgettext('UploadInvoiceLines')"
          :href="downloadTemplateURL"
          button
          variant="light"
          use-auth
          force-download
        >
        </ItpLink>
      </p>
    </ItpAlert>
    <hr>
    </hr>
    <DIV
      class="container"
    >
      <ItpForm
        :name="formName"
        :id="formId"
        v-if="loaded"
        @submit="evh_648747096704084_submit($event, {})"
      >
        <ItpFormGroup
          name="file"
          :label="'Invoice lines file'|pgettext('UploadInvoiceLines')"
          labelFor="file"
          :description="'Please select a filled-in template file.'|pgettext('UploadInvoiceLines')"
          required
        >
          <ItpFormFile
            v-model="file"
            name="file"
            accept=".xlsx"
            required
            :validation="b_3086171180629160_validation"
          >
          </ItpFormFile>
        </ItpFormGroup>
      </ItpForm>
      <ItpAlert
        :show="resultText && !actions.submit.isRunning"
      >
        <p>
          {{ resultText }}
        </p>
      </ItpAlert>
    </DIV>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="formId"
      :text="'Upload lines'|pgettext('UploadInvoiceLines')"
      type="submit"
      variant="primary"
      icon="fa-file-import"
      :spinning="actions.submit.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UploadInvoiceLines extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  file!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  resultText!: any;
  downloadTemplateURL!: any;

  async $$load_downloadTemplateURL() {
    return this.$fn.urlFor('download_file_template_invoice_lines_upload')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3086171180629160_validation!: any;
  dataMembers = ['file', 'formId', 'formName', 'resultText', 'downloadTemplateURL', 'ux', 'b_7315092382398562_modalBindings', 'b_3086171180629160_validation'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        file: null,
        formId: null,
        formName: "UploadInvoiceLines",
        resultText: null,
        downloadTemplateURL: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
        b_3086171180629160_validation: ["ext:xlsx"
          ,
          "required"
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("UploadInvoiceLines|Title", "Upload invoice lines"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_9352_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_9352, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_648747096704084_register_9358_getActionArgs($event: actions.ActionEvent): Promise<actions.RegisterActionArgs> {
    // parameterResolver name=act_648747096704084_register_9358, alias=undefined
    return {
      name: "resultLength",
      value: $event.data.response.data ? $event.data.response.data.length : 0,
    }
  }

  async act_648747096704084_setData_9360_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_648747096704084_setData_9360, alias=undefined
    return {
      path: "resultText",
      value: this.$fn.ngettext("One line has been imported.", "${n} lines have been imported.", this.resultLength),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_648747096704084_success_9359_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_648747096704084_success_9359, alias=undefined
    return $event.data.resultLength > 0
  }

  async act_648747096704084_setData_9362_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_648747096704084_setData_9362, alias=undefined
    return {
      path: "resultText",
      value: this.$fn.gettext("No lines have been imported."),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_648747096704084_success_9361_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_648747096704084_success_9361, alias=undefined
    return !$event.data.resultLength
  }

  async act_648747096704084_request_9356_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_648747096704084_request_9356, alias=submit
    return {
      operation: "upload_invoice_lines",
      data: { file: this.file },
      parameters: {
        invoice_id: this.invoice.id,
      }
      ,
      contentType: "multipart/form-data",
    }
  }

  async evh_648747096704084_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_648747096704084_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_9364_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_9364, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_9352: actions.CloseModalAction;
    evh_7315092382398562_close_9351: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_9354: actions.CloseComponentAction;
    evh_2248226175642056_close_9353: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_648747096704084_register_9358: actions.RegisterAction;
    evh_648747096704084_success_9357: actions.EventHandlerImpl;
    act_648747096704084_setData_9360: actions.SetDataAction;
    evh_648747096704084_success_9359: actions.EventHandlerImpl;
    act_648747096704084_setData_9362: actions.SetDataAction;
    evh_648747096704084_success_9361: actions.EventHandlerImpl;
    act_648747096704084_request_9356: actions.RequestAction;
    evh_648747096704084_submit_9355: actions.EventHandlerImpl;
    evh_648747096704084_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_9364: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_9363: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_9352 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_9352_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_9351 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_9352,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_9351],
      }
    );
    const act_2248226175642056_closeComponent_9354 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_9353 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_9354,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_9353],
      }
    );
    const act_648747096704084_register_9358 = new actions.RegisterAction(
      {
        actionArgs: this.act_648747096704084_register_9358_getActionArgs,
        events: [],
      }
    );
    const evh_648747096704084_success_9357 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_register_9358,
        event: "success",
        displayName: "register",
      }
    );
    const act_648747096704084_setData_9360 = new actions.SetDataAction(
      {
        actionArgs: this.act_648747096704084_setData_9360_getActionArgs,
        events: [],
      }
    );
    const evh_648747096704084_success_9359 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_setData_9360,
        event: "success",
        when: this.evh_648747096704084_success_9359_getWhen,
        displayName: "setData",
      }
    );
    const act_648747096704084_setData_9362 = new actions.SetDataAction(
      {
        actionArgs: this.act_648747096704084_setData_9362_getActionArgs,
        events: [],
      }
    );
    const evh_648747096704084_success_9361 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_setData_9362,
        event: "success",
        when: this.evh_648747096704084_success_9361_getWhen,
        displayName: "setData",
      }
    );
    const act_648747096704084_request_9356 = new actions.RequestAction(
      {
        actionArgs: this.act_648747096704084_request_9356_getActionArgs,
        displayName: "submit",
        events: [evh_648747096704084_success_9357, evh_648747096704084_success_9359, evh_648747096704084_success_9361],
      }
    );
    const evh_648747096704084_submit_9355 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_request_9356,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_648747096704084_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_648747096704084_submit_9355],
      }
    );
    const act_1419464017721962_closeModal_9364 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_9364_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_9363 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_9364,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_9363],
      }
    );
    return {
      act_7315092382398562_closeModal_9352,
      evh_7315092382398562_close_9351,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_9354,
      evh_2248226175642056_close_9353,
      evh_2248226175642056_close,
      act_648747096704084_register_9358,
      evh_648747096704084_success_9357,
      act_648747096704084_setData_9360,
      evh_648747096704084_success_9359,
      act_648747096704084_setData_9362,
      evh_648747096704084_success_9361,
      act_648747096704084_request_9356,
      evh_648747096704084_submit_9355,
      evh_648747096704084_submit,
      act_1419464017721962_closeModal_9364,
      evh_1419464017721962_clickPreventStop_9363,
      evh_1419464017721962_clickPreventStop,
      submit: act_648747096704084_request_9356,
    }
  }
}

Vue.component("UploadInvoiceLines", UploadInvoiceLines);

</script>